import ButtonBase from "@material-ui/core/ButtonBase";
import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from "@material-ui/icons/Clear";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { buttonStyles, colorPallete } from "../styles";
import "../styles/globalStyles.css";

export const DynamicButton = props => {
  const classes = buttonStyles();
  const colors = colorPallete();
  const [color, setColor] = useState(colors.neutralDark);
  const [active, toggleActive] = useState(props.active);
  const [endIcon, updateEndIcon] = useState(false);
  const [startIcon, updatestartIcon] = useState(false);
  // const [trueClass, setClass] = useState(props.trueClass);

  // const dynamicChange = props => {
  //   props();
  //   return color === classes.neutralDark
  //     ? setColor(classes.accentGreen)
  //     : setColor(classes.neutralDark);
  // };

  const setEndIcon = endIcon => {
    //TODO set colors of icons to be selected dynamically
    switch (endIcon) {
      case "check":
        return <CheckIcon className="correctIcon" />;
      case "wrong":
        return <ClearIcon className="incorrectIcon" />;
      default:
        return false;
    }
  };

  useEffect(() => {
    setColor(props.selected === true ? props.trueColor : props.falseColor);
  }, [props.selected]);

  useEffect(() => {
    updateEndIcon(props.endIcon !== false ? setEndIcon(props.endIcon) : false);
  }, [props.endIcon]);

  return (
    <ButtonBase
      className={clsx(color, classes.primary, props.className)}
      variant={props.variant || "text"}
      disabled={props.disabled || false}
      disabledElevation={props.disabledElevation || false}
      disableFocusRipple={props.disableFocusRipple || false}
      fullWidth={props.fullWidth || false}
      href={props.href || ""}
      size={props.size || "medium"}
      onClick={() => props.onClick()}
    >
      <div className="dynamicButtonInternal">
        {startIcon !== false ? startIcon : null} {props.children}{" "}
        {endIcon !== false ? endIcon : null}
      </div>
    </ButtonBase>
  );
};
